import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeaturedRewardsComponent } from './featured-rewards.component';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { MixedLoyaltyItemModule } from '@fgb/portal-component-library/src/lib/loyalty/mixed-loyalty';

@NgModule({
  declarations: [FeaturedRewardsComponent],
  imports: [CommonModule, CarouselModule, MixedLoyaltyItemModule, RouterModule, DirectivesModule, FGBSharedModule],
  exports: [FeaturedRewardsComponent],
})
export class FeaturedRewardsModule {}
